"use client";

import ErrorBoundary from './ErrorBoundary';
import { useEffect } from 'react';

export default function ErrorBoundaryClient({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Логируем ошибки гидратации
    const handleError = (event: ErrorEvent) => {
      console.error('[Hydration Error]', event.error);
      console.error('[Error Stack]', event.error?.stack);
    };

    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  return <ErrorBoundary>{children}</ErrorBoundary>;
}
